var map = {
	"./ar/AboutUs": 490,
	"./ar/AboutUs.js": 490,
	"./ar/Albums": 1935,
	"./ar/Albums.js": 1935,
	"./ar/Categories": 1734,
	"./ar/Categories.js": 1734,
	"./ar/Dashboard": 6904,
	"./ar/Dashboard.js": 6904,
	"./ar/Filters": 2530,
	"./ar/Filters.js": 2530,
	"./ar/Keywords": 8312,
	"./ar/Keywords.js": 8312,
	"./ar/Login": 8005,
	"./ar/Login.js": 8005,
	"./ar/Navbar": 1081,
	"./ar/Navbar.js": 1081,
	"./ar/NavigationDrawer": 3135,
	"./ar/NavigationDrawer.js": 3135,
	"./ar/News": 9720,
	"./ar/News.js": 9720,
	"./ar/Order": 5769,
	"./ar/Order.js": 5769,
	"./ar/Orders": 2245,
	"./ar/Orders.js": 2245,
	"./ar/Products": 3427,
	"./ar/Products.js": 3427,
	"./ar/SEOpage": 1542,
	"./ar/SEOpage.js": 1542,
	"./ar/Sets": 1001,
	"./ar/Sets.js": 1001,
	"./ar/Sliders": 1703,
	"./ar/Sliders.js": 1703,
	"./ar/Subscriptions": 7595,
	"./ar/Subscriptions.js": 7595,
	"./ar/Users": 3605,
	"./ar/Users.js": 3605,
	"./en/AboutUs": 9559,
	"./en/AboutUs.js": 9559,
	"./en/Albums": 2418,
	"./en/Albums.js": 2418,
	"./en/Categories": 809,
	"./en/Categories.js": 809,
	"./en/Dashboard": 3553,
	"./en/Dashboard.js": 3553,
	"./en/Filters": 7316,
	"./en/Filters.js": 7316,
	"./en/Keywords": 5349,
	"./en/Keywords.js": 5349,
	"./en/Login": 1316,
	"./en/Login.js": 1316,
	"./en/Navbar": 930,
	"./en/Navbar.js": 930,
	"./en/NavigationDrawer": 6627,
	"./en/NavigationDrawer.js": 6627,
	"./en/News": 3858,
	"./en/News.js": 3858,
	"./en/Order": 2407,
	"./en/Order.js": 2407,
	"./en/Orders": 4079,
	"./en/Orders.js": 4079,
	"./en/Products": 5979,
	"./en/Products.js": 5979,
	"./en/SEOpage": 4045,
	"./en/SEOpage.js": 4045,
	"./en/Sets": 8395,
	"./en/Sets.js": 8395,
	"./en/Sliders": 9801,
	"./en/Sliders.js": 9801,
	"./en/Subscriptions": 9743,
	"./en/Subscriptions.js": 9743,
	"./en/Users": 5638,
	"./en/Users.js": 5638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2980;